export default __webpack_public_path__ + "static/media/marzec.46e6841c.mp3";